<h1 mat-dialog-title>{{ title }}</h1>
<mat-dialog-content>
  <p>{{ text }}</p>

  <div *ngIf="showFailReasonDropDown" class="address-fail-reason">
    <mat-select [(ngModel)]="failReason" placeholder="Select a reason">
      <mat-option *ngFor="let reason of failReasons" [value]="reason">
        {{ reason.description }}
      </mat-option>
    </mat-select>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button (click)="onNoClick()" cdkFocusInitial color="accent" mat-raised-button>{{ cancel }}</button>
  <button (click)="onYesClick()" [disabled]="isYesDisabled()" color="primary" mat-raised-button>{{ confirm }}</button>
</mat-dialog-actions>
